import { useGetIdentity } from "ra-core";
import { CreateButton } from "@/components/admin/create-button";
import { DataTable } from "@/components/admin/data-table";
import { DateField } from "@/components/admin/date-field";
import { FilterButton } from "@/components/admin/filter-form";
import { List } from "@/components/admin/list";
import { ReferenceField } from "@/components/admin/reference-field";
import { SearchInput } from "@/components/admin/search-input";
import { SelectInput } from "@/components/admin/select-input";
import { SortButton } from "@/components/admin/sort-button";
import { Badge } from "@/components/ui/badge";

import { TopToolbar } from "../layout/TopToolbar";
import type { ProspectActivity } from "../types";
import { ActivityDoneToggle } from "./ActivityDoneToggle";
import { activityTypeLabel, activityTypes } from "./activityModel";

const activityFilters = [
  <SearchInput source="q" alwaysOn />,
  <SelectInput source="type" choices={activityTypes} />,
];

const ActivityListActions = () => (
  <TopToolbar>
    <SortButton fields={["starts_at", "priority", "type"]} />
    <FilterButton />
    <CreateButton />
  </TopToolbar>
);

export const ActivityList = () => {
  const { identity } = useGetIdentity();
  if (!identity) return null;

  return (
    <List
      title="Calendar"
      actions={<ActivityListActions />}
      filters={activityFilters}
      filterDefaultValues={{ "completed_at@is": null }}
      perPage={50}
      sort={{ field: "starts_at", order: "ASC" }}
    >
      <DataTable rowClassName={() => "cursor-pointer"}>
        <DataTable.Col label="">
          <ActivityDoneToggle />
        </DataTable.Col>
        <DataTable.Col source="starts_at" label="When">
          <DateField source="starts_at" showTime />
        </DataTable.Col>
        <DataTable.Col
          source="type"
          label="Type"
          render={(record: ProspectActivity) => activityTypeLabel(record.type)}
        />
        <DataTable.Col source="title" label="Title" />
        <DataTable.Col label="Prospect">
          <ReferenceField
            source="prospect_id"
            reference="prospects"
            link="show"
          />
        </DataTable.Col>
        <DataTable.Col
          source="priority"
          label="Priority"
          render={(record: ProspectActivity) =>
            record.priority === "high" ? (
              <Badge variant="destructive">High</Badge>
            ) : (
              <span className="text-muted-foreground">{record.priority}</span>
            )
          }
        />
      </DataTable>
    </List>
  );
};
